module.exports = __webpack_public_path__ + "img/tuev_logo.8c563607.png";